import type React from "react"
import { memo } from "react"
import { twMerge } from "tailwind-merge"

type SectionHeaderTitleProps = {
  label: string
  description?: string | React.ReactElement
  gap?: number
}

const SectionHeaderTitle: React.FC<SectionHeaderTitleProps> = ({ label, description, gap }) => {
  return (
    <div className={twMerge("p-4", description && "flex flex-col gap-y-6", gap && `gap-y-${gap}`)}>
      <span className="text-pn-large-title">{label}</span>
      {typeof description === "string" ? (
        <span className="text-pn-body-regular text-pn_gray-600">{description}</span>
      ) : (
        description
      )}
    </div>
  )
}
export default memo(SectionHeaderTitle)
